import React from 'react';
import {
  IonCard,
  IonCardTitle,
  IonCardContent,
  IonRow,
  IonCol,
  isPlatform,
  IonContent
} from "@ionic/react";
import i18n from "i18n";
import "./RateDetails.scss";
import Rate from '../Rate/Rate';
import RateHeader from '../RateHeader/RateHeader';
import {ComponentProps} from './RateDetails.types';

export default ({ shipmentCostItems, costCurrency, totalCostAmount }: ComponentProps) => {
  const isMobile = isPlatform("mobile");
  const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: costCurrency || "USD",
    minimumFractionDigits: 2
  });

  const padding = (shipmentCostItems.length>3) ? "total-cost-padding" : "";

  return (
    <IonCard
      className="rate-details-component"
      data-testid={"rate-details-component"}
      style={{ border: isMobile ? "none" : "0.5px solid #dedede" }}
    >
      <IonCardTitle
        className={`title ${isMobile ? ' title-padding-mobile': ''}`}
        data-testid="title"
        style={{ textAlign: isMobile ? "center" : "left" }}
      >
        {i18n.t("Rate Details")}
      </IonCardTitle>
      <IonCardContent>
        <RateHeader length={shipmentCostItems.length}/>
        <IonContent className={isMobile ? "rate-list-mobile" : "rate-list"} data-testid={"rate-detail-list"}>
          {shipmentCostItems.map(({ costBreakdownDescription, costBreakdownRate, costBreakdownRateQlfr, costBreakdownQty, costBreakdownTotalAmount }: any, index:any) => (
            <Rate
              costBreakdownDescription={costBreakdownDescription}
              costBreakdownRate={costBreakdownRate}
              costBreakdownRateQlfr={costBreakdownRateQlfr}
              costBreakdownQty={costBreakdownQty}
              costBreakdownTotalAmount={costBreakdownTotalAmount}
              key={`${costBreakdownDescription}_${index}`}
              costCurrency={costCurrency}
              length={shipmentCostItems?.length}
            />
          ))}
        </IonContent>
        <IonRow className={isMobile?"total-cost-row-mobile":"total-cost-row-web"}>
          <IonCol data-testid="total-cost" size="4" className={"total-label bold-text"}>
            Total
          </IonCol>
          <IonCol size="2"/>
          <IonCol data-testid="total-cost-amount" size="6" className={isMobile ? "total-cost bold-text":`total-cost bold-text ${padding}`}>
            {currencyFormatter.format(totalCostAmount || 0)}
          </IonCol>
        </IonRow>
      </IonCardContent>
    </IonCard>
  );
}